import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-088e19c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = { class: "avatar-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "icon-mic-off"
}
const _hoisted_4 = { class: "icon-camera-off" }
const _hoisted_5 = { class: "number" }
const _hoisted_6 = {
  key: 0,
  class: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["without-video", _ctx.blockClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          color: "--sui-gray-400",
          name: "ic24-user",
          width: "42",
          height: "46"
        }),
        (_ctx.isRemoteMute)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Icon, {
                class: "icon-mute",
                color: "--sui-white",
                name: "ic24-mic-off",
                width: "20",
                height: "20"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Icon, {
            class: "icon-mute",
            color: "--sui-white",
            spriteUrl: "static/icons-pack.svg",
            name: "ic24-videocamera-mute",
            width: "20",
            height: "20"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Hint, {
          text: _ctx.selectCall?.status !== 'PROGRESSING' && _ctx.selectCall?.status !== 'CONNECTED' && _ctx.settingsState.minimize ? _ctx.t(`errors.${_ctx.selectCall?.status}`) : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Typography, {
              class: "phone-number",
              fontColor: _ctx.getColor ? '--sui-white' : '--sui-gray-900',
              fontSize: _ctx.isWindow ? '14px' : '16px'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectCall?.number), 1)
              ]),
              _: 1
            }, 8, ["fontColor", "fontSize"])
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      (!_ctx.isWindow && !_ctx.settingsState.maximize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_ctx.settingsState.minimize)
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 0,
                  class: "call-time"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectCall?.status === 'CONNECTED' && !_ctx.selectCall.active ? `${_ctx.t('statuses.pause')}  ·  ` : ''), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.callDuration[_ctx.selectCall?.id] && _ctx.selectCall?.status === 'CONNECTED')
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 1,
                  class: "call-time"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectCall?.active ? _ctx.timeFormat(_ctx.callDuration[_ctx.selectCall.id].callDuration) : _ctx.timeFormat(_ctx.callDuration[_ctx.selectCall?.id].pauseDuration)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showLoading)
              ? (_openBlock(), _createBlock(_component_Loading, {
                  key: 2,
                  class: "animation"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}